(function () {
    'use strict';


    var extDeps = [];
    var module = angular.module('app.common.infra', extDeps);




    /**
     * Provides global contstants for the application
     */
    module.provider('appGlobals', appGlobalsProvider);
    function appGlobalsProvider($windowProvider) {

        var w = $windowProvider.$get();
        var matches;

        matches = w.location.href.match(/useRavenLocalLog=([\w]+)/i);
        if(matches)
            w.sessionStorage.useRavenLocalLog = matches[1];

        var stubsAreEnabled = w.location.href.match(/^https?:\/\/(myconnect-dev|myconnect-sit|[\w\.]+\.cloudapp\.azure\.com|localhost)/gi);
        return {
            $get: function () {
                var ss = w.sessionStorage;
                return {
                    useRavenLocalLog :  (/true/i).test(ss.useRavenLocalLog)
                    , signoutUrl : '/app/account/signout/1'
                    , stubsAreEnabled: stubsAreEnabled
                };
            }
        };
    }



    module.run(runModule);
    function runModule($raven,userService,inactivityTimeoutBuster){

        _init();

        function _init(){

            userService.getUserAsync()
                .then(function(result){
                    // Set the user context to log errors with Sentry
                    $raven.setUserContext({
                        id: result.displayTitle
                    });
                });


            inactivityTimeoutBuster.bustOnMouseMove();
            inactivityTimeoutBuster.bustOnKeyPress();
        }
    }




    /**
     * SERVICES
     */


    /**
     * Configures the javascript exception capture library that logs to Sentry
     */
    module.config(configureRaven);
    function configureRaven($ravenProvider,appGlobalsProvider) {

        // There is a development flag to log errors rather than sending it to Sentry
        var globals = appGlobalsProvider.$get();
        if(globals.useRavenLocalLog)
            $ravenProvider.development(true);

    }


    /**
     * Configure http interceptors (httpErrorInterceptor,devEnvHttpInterceptor)
     */
    module.config(configureHttpInterceptors);
    function configureHttpInterceptors($httpProvider) {
        $httpProvider.interceptors.push('httpErrorInterceptor');
    }







    /**
     * Displays a modal dialog window whenever an error is raised
     * and also pushes error information to sentry through the raven library
     */
    module.factory('httpErrorInterceptor', httpErrorInterceptor);
    function httpErrorInterceptor($q, $injector,  $raven, appGlobals){


        return {
            responseError: _error
            , requestError: _error
        };

        function _error(response) {


            // it is some kind of windows custom network related error so let it go through
            // https://msdn.microsoft.com/en-us/library/windows/desktop/aa383770(v=vs.85).aspx
            if(response.status > 12000)
                $q.reject(response);

            // normalize to camelcase
            if (!response.data)
                response.data = {};

            if (response.data.Message)
                response.data.message = response.data.Message;

            // if message is a json object
            var displayMessage = 'Please try again later';
            if((/string/i).test(typeof response.data.message))
                displayMessage = response.data.message.length > 500 ? response.data.message.substr(0, 500) + '...' : response.data.message;
            else
                displayMessage = JSON.stringify(response.data.message)


            var modalService = $injector.get('modalService');
            var $window = $injector.get('$window');

            console.log('Status: ' + response.status + ' Message: ' + displayMessage);

            // [SS: Seeing -1 being returned when CORS error thrown in redirect to Azure login]
            if ((/^(-1|0)$/).test(response.status)) {
                if ((/heartbeat/i).test(response.config.url) == false) {
                    /*redirect to home on conn issue*/
                    $window.location.href = '/';
                    /*modalService.notifyMessage({
                        title: 'Network error or disconnection'
                        , message: 'Please try again.'
                        , type: 'info'
                    });*/
                }
            }
            else if ((/^(401|403)$/).test(response.status)) {
                modalService.notifyMessage({
                    title: 'Session timeout'
                    , message: 'Your session has timed out. Please log-in again.'
                    , type: 'info'
                }).finally(function(){
                    return ($window.location.href=appGlobals.signoutUrl);
                });
            }
            else if ((/^(422)$/).test(response.status)) {
                // Let the angular resource handle it directly
            }
            else if ((/^(400)$/).test(response.status)) {

                // bad request gets thrown when validating
                modalService.notifyMessage({
                    title: 'Something went wrong'
                    , message: displayMessage
                    , type: 'alert'
                });
            }
            else {
                // display generic error message
                modalService.notifyMessage({
                    title: 'Something went wrong'
                    , message: displayMessage
                    , type: 'error'
                });
            }

            // send to sentry
            //_notifyErrorToSentry(response);

            return $q.reject(response);
        }

        // previously used to capture javascript errors
        //function _notifyErrorToSentry(response){
        //
        //    var msg = [
        //        response.config.method
        //        , response.config.url
        //        , response.status
        //        , '(' + response.statusText + ')'
        //        , '\n'
        //        , angular.toJson(response,true)
        //
        //    ].join(' ');
        //
        //    $raven.captureMessage(
        //        msg
        //        , {
        //            level: (/404/).test(response.status) ? 'warning' : 'error'
        //            , tags: { "http-status": response.status + ' (' + response.statusText + ')' }
        //        }
        //    );
        //}

    }



    /**
     * Informs an endpoint about activity on the page
     */
    module.factory('inactivityTimeoutBuster', inactivityTimeoutBuster);

    function inactivityTimeoutBuster(HeartbeatApi, debounce){

        var bounceTimeout = 500;
        bounceTimeout = 2000;

        var informActivity = (function (f) {
            return debounce(f, bounceTimeout, false);
        })(informActivityFunc);

        return {
            scheduleBust: informActivity
            , immediateBust: informActivityFunc
            , bustOnMouseMove: bustOnMouseMove
            , bustOnKeyPress:bustOnKeyPress
        };

        function informActivityFunc(){
            HeartbeatApi.update();
        }

        function bustOnMouseMove(yes){
            if(yes || yes === undefined){
                $(document)
                    .off('mousemove',informActivity)
                    .on('mousemove',informActivity);
            }else{
                $(document)
                    .off('mousemove',informActivity);
            }
        }

        function bustOnKeyPress(yes){
            if(yes || yes === undefined){
                $(document)
                    .off('keyup',informActivity)
                    .on('keyup',informActivity);
            }else{
                $(document)
                    .off('keyup',informActivity);
            }
        }
    }



})();
